import Breadcrumbs from "@/components/Breadcrumbs";
import { useBreadcrumbs, useMatchMedia, useScrollDirection } from "@/hooks";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import { useEffect, useRef } from "react";
import Stickyfill from "stickyfill";
import HeaderLogo from "./HeaderLogo";
import PrimaryNavigation from "./PrimaryNavigation";
import PrimaryNavigationForSp from "./PrimaryNavigationForSp";
import SecondaryNavigation from "./SecondaryNavigation";

function Header({ noHeader, noTransition }) {
  const header = useRef();
  const { breadcrumbs } = useBreadcrumbs();
  const viewBreadcrumbs = breadcrumbs.length > 0;
  const direction = useScrollDirection(50);

  useEffect(() => {
    if (typeof window !== "undefined" && header.current) {
      // IE11 polyfill
      const stickyfill = Stickyfill();
      stickyfill.add(header.current);
    }
  }, [header.current]);

  const mobileSize = useMatchMedia(
    [{ query: "screen and (max-width: 780px)", value: true }],
    false
  );

  return (
    <header
      ref={header}
      className={classnames(styles.header, {
        [styles.viewSubHeader]: !mobileSize && viewBreadcrumbs,
        [styles.scrollUp]: direction === "up",
        [styles.scrollDown]: direction === "down",
      })}
    >
      <div className={styles.container}>
        <div className={styles.main}>
          <HeaderLogo anoTransition={noTransition} />
          {!noHeader && (
            <>
              <PrimaryNavigation />
              <SecondaryNavigation />
            </>
          )}
        </div>
        {!noHeader && <PrimaryNavigationForSp />}
        <div
          className={classnames(styles.sub, {
            hidden: !viewBreadcrumbs || noHeader,
          })}
        >
          <Breadcrumbs hidden={!viewBreadcrumbs} />
        </div>
      </div>
    </header>
  );
}

export default Header;
